<template>
  <div class="content mb-5">
    <b-loading :is-full-page="false" :active.sync="loading" />
    <form v-if="!success" class="form width500 centered" @submit.prevent="submit">
      <b-field
        :label="$t('fields.email')"
        :type="{'is-danger': errors.has('userEmail')}"
        :message="errors.first('userEmail')"
      >
        <b-input
          v-model="email"
          v-validate="'required'"
          type="email"
          name="userEmail"
          size="is-medium"
        />
      </b-field>
      <div class="buttons-set m-t-30">
        <button type="submit" class="button is-success is-large is-fullwidth" :disabled="loading">
          {{ $t('forgotPassword.send_mail') }}
        </button>
      </div>
    </form>
    <b-notification v-else type="is-success" :closable="false" class="">
      <div class="columns is-mobile is-vcentered">
        <div class="column is-narrow">
          <b-icon size="is-large" icon="check" />
        </div>
        <div class="column">
          {{ $t('forgotPassword.success') }}
        </div>
      </div>
    </b-notification>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      loading: false,
      success: false
    }
  },
  methods: {
    submit () {
      this.$validator.validate().then((result) => {
        if (result) {
          this.loading = true
          this.$api.passwordReset.email({ email: this.email })
            .then((response) => {
              this.loading = false
              this.success = true
            })
            .catch((e) => {
              this.loading = false
              if (e.response.data.error === 'EMAIL_NOT_FOUND') {
                this.$buefy.toast.open({
                  message: this.$t('forgotPassword.warning', { email: this.email }),
                  type: 'is-warning'
                })
              } else {
                this.$buefy.toast.open({
                  message: this.$t('forgotPassword.error'),
                  type: 'is-danger'
                })
              }
            })
        }
      })
    }
  }
}
</script>
